// @flow
import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import FontService from '../../../lib/font';
import theme from '../../../theme-config';

type Step = {
  label: string,
};

type Props = {
  currentStep: number,
  steps: Step[],
  onStepPress: (index: number) => void,
};

const Stepper = ({ currentStep, steps, onStepPress }: Props) => (
  <View style={styles.container}>
    {steps.map((step, index) => {
      const isActive = index === currentStep;
      const isLast = index === steps.length - 1;

      return (
        <React.Fragment key={index}>
          <TouchableOpacity
            style={styles.stepItem}
            onPress={() => onStepPress(index)}
            activeOpacity={0.7}
            testID={`stepper-step-${index}`}
          >
            <Text
              style={[
                styles.label,
                isActive ? styles.labelActive : styles.labelInactive,
              ]}
            >
              {step.label}
            </Text>
            <View
              style={[
                styles.circle,
                isActive ? styles.circleActive : styles.circleInactive,
              ]}
            >
              <Text
                style={[
                  styles.circleText,
                  isActive ? styles.circleTextActive : styles.circleTextInactive,
                ]}
              >
                {index + 1}
              </Text>
            </View>
          </TouchableOpacity>
          {!isLast && (
            <View
              style={[
                styles.line,
                isActive && currentStep > index
                  ? styles.lineActive
                  : styles.lineInactive,
              ]}
            />
          )}
        </React.Fragment>
      );
    })}
  </View>
);

const CIRCLE_SIZE = 28;

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 80,
    paddingVertical: 15,
  },
  stepItem: {
    alignItems: 'center',
  },
  circle: {
    width: CIRCLE_SIZE,
    height: CIRCLE_SIZE,
    borderRadius: CIRCLE_SIZE / 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  circleActive: {
    backgroundColor: theme.secondaryColor,
  },
  circleInactive: {
    borderWidth: 2,
    borderColor: theme.secondaryColor,
    backgroundColor: 'transparent',
  },
  circleText: {
    fontSize: 14,
    fontWeight: 'bold',
    ...FontService.getStyle(theme.fontFamily, 'bold', false),
  },
  circleTextActive: {
    color: '#FFFFFF',
  },
  circleTextInactive: {
    color: theme.secondaryColor,
  },
  label: {
    marginBottom: 4,
    fontSize: 12,
  },
  labelActive: {
    color: theme.secondaryColor,
    fontSize: 13,
    fontWeight: 'bold',
    ...FontService.getStyle(theme.fontFamily, 'bold', false),
  },
  labelInactive: {
    color: theme.secondaryColor,
    fontSize: 13,
  },
  line: {
    flex: 1,
    height: 1.5,
    marginTop: 18,
    marginHorizontal: 8,
  },
  lineActive: {
    backgroundColor: theme.secondaryColor,
  },
  lineInactive: {
    backgroundColor: theme.gray.normalLight,
  },
});

export default Stepper;
